import React from 'react';
import { connect } from 'react-redux';
import {
	openChildInput,
	openInput,
	setCityByCode,
	setLocationByIATACode,
	setLocationByZip,
} from '../../../actions/baseActions';
import { selectFromLocation } from '../../../actions/carActions';
import { CAR_SELECT_FROM_LOCATION } from '../../../actions/types';
import Helper from '../../modules/Helper';
import AirportSelect from '../Common/AirportSelect';
import { IAirportItem } from '../Common/AirportSelect/Item';

type AirportSelectFromProps = {
	name: string;
	countryCode: string;
	selectedFromLocation?: IAirportItem;
	autoJump?: boolean;
	preventFocus?: boolean;
	preventSetInputBoxClassName?: boolean;
	enableReturnLocation?: boolean;
	selectFromLocation: (item: IAirportItem | object) => void;
	openInput: (name?: string | null) => void;
	openChildInput: (name?: string | null) => void;
	setCityByCode: (location: string, type: string) => void;
	setLocationByIATACode: (location: string, type: string, lng?: string) => void;
	setLocationByZip: (location: string, type: string) => void;
};

class AirportSelectFrom extends React.Component<AirportSelectFromProps> {
	componentDidMount() {
		setTimeout(() => {
			const parsed = Helper.parseQueryString(window.location.search, true);
			if (Helper.isEmpty(this.props.selectedFromLocation)) {
				const inputElement = document.getElementById(this.props.name + '-input') as HTMLInputElement;

				if (inputElement) {
					inputElement.focus();
					inputElement.select();
				}
			}
			if (!!parsed.origcode && parsed.origcode !== 'undefined' && parsed.origcode !== 'None') {
				if (!Helper.hasNumber(parsed.origcode)) {
					this.props.setLocationByIATACode(parsed.origcode.toString().toUpperCase(), CAR_SELECT_FROM_LOCATION, parsed.lng?.toString());
				} else if (parsed.hasOwnProperty('pickup-destination-id') && parsed['pickup-destination-id'] === 'zipcode') {
					this.props.setLocationByZip(parsed.origcode as string, CAR_SELECT_FROM_LOCATION);
				} else {
					this.props.setCityByCode(parsed.origcode as string, CAR_SELECT_FROM_LOCATION);
				}
			}
		}, 1);
	}

	componentDidUpdate() {
		const { selectedFromLocation, name } = this.props;
		const input = document.getElementById(name + '-input') as HTMLInputElement;

		if (!Helper.isEmpty(selectedFromLocation) && input) {
			input.disabled = true;
			input.disabled = false;
		}
	}

	onSelect = (location: IAirportItem | object) => {
		this.props.selectFromLocation(location);

		if (!this.props.autoJump) {
			return this.props.openInput();
		}

		if (this.props.enableReturnLocation) {
			this.props.openInput('airport-to');

			if (!this.props.preventFocus) {
				const input = document.getElementById('airport-to-input') as HTMLInputElement;
				input.focus();
				input.select();
			}
		} else {
			this.props.openInput('date-from');
			this.props.openChildInput('from-date-picker');
		}
	};

	render() {
		const { countryCode, selectedFromLocation, name, preventSetInputBoxClassName } = this.props;
		const placeholder = 'main.cars.pickUpLocation';
		const searchForZipCode = countryCode === 'US';
		return (
			<AirportSelect
				i18nValidationDropDownKey="validation.cars.pickUpLocationSelectFromDropDown"
				preventSetInputBoxClassName={preventSetInputBoxClassName}
				icon="icon-car-7-outline"
				placeholder={Helper.trans(placeholder)}
				searchForZipCode={searchForZipCode}
				selected={selectedFromLocation}
				name={name}
				onSelect={this.onSelect}
			/>
		);
	}
}

// @ts-ignore
const mapStateToProps = (state) => ({
	selectedFromLocation: state.car.selectedFromLocation,
	enableReturnLocation: state.car.enableReturnLocation,
	autoJump: state.base.autoJump,
	countryCode: state.base.countryCode,
	preventFocus: state.base.preventFocus,
});

export default connect(mapStateToProps, {
	selectFromLocation,
	openInput,
	openChildInput,
	setCityByCode,
	setLocationByIATACode,
	setLocationByZip,
})(AirportSelectFrom);
